module.exports = __webpack_public_path__ + "img/6.460b8e50.svg";